import React from 'react';
import { SnackbarContext } from '@/contexts/Snackbar';

export const useSnackbar = () => React.useContext(SnackbarContext);
